<template>
    <modal
       v-if="program_links.length > 0"
       :title="translations.referralUrl || 'Referral URL'"
       :cancel_btn_title="translations.cancel || 'Cancel'"
       size="small"
       name="partner_add_custom_link"
    >
        <template #toggle>
            <btn type="light">
                {{ translations.createNewReferralUrl || 'Create new referral URL' }}
            </btn>
        </template>
        <template #body>
            <div class="space-y-4">
                <div>
                    <select id="program_custom_link" name="program_custom_link" v-model="program_link_index"
                            @change="programLinkChange"
                            class="block w-full rounded border-gray-300 sm:text-sm focus:ring-0 focus:border-gray-400">
                        <option v-for="(link, index) in program_links" v-bind:value="index">
                            {{ link.domain }}
                        </option>
                    </select>
                </div>
                <text-field
                    :label="translations.identificationCode || 'Identification code'"
                    :model-value="key"
                    field-id="identification"
                    @update:modelValue="updateRefLink"
                    v-on:keyup.enter="addCustomLink"
                    :error="error ? true : false"
                    :error-message="error"
                ></text-field>
                <div
                    class="py-3 px-4 text-sm bg-gray-100 text-gray-900 text-opacity-60 rounded flex items-center space-x-1.5">
                    <icon name="link"></icon>
                    <span>{{ ref_link }}</span>
                </div>
            </div>
        </template>
        <template #footer>
            <btn v-on:click="addCustomLink" :loading="loading" :disabled="!create_allowed">
                {{ translations.create || 'Create' }}
            </btn>
        </template>
    </modal>
</template>
<script>
export default {
    props: ['program_links', 'add_url', 'translations'],
    data() {
        return {
            key: '',
            error: false,
            loading: false,
            create_allowed: false,
            program_link_index: 0,
            program_link: this.program_links[0],
        }
    },
    methods: {
        addCustomLink() {

            if (this.loading || !this.create_allowed) {
                return;
            }

            this.error = false;
            this.loading = true;

            axios
                .post(this.add_url, {key: this.key, domain_id: this.program_link.id, is_additional: this.program_link.is_additional})
                .then(response => {
                    const status = parseInt(response.data.status ?? 0);
                    if (status === 1) {
                        this.emitter.emit('modal-off', 'partner_add_custom_link');
                        window.location.reload();
                    } else {
                        this.error = 'Failed to add custom link';
                    }
                })
                .catch(error => {
                    let errors = error.response.data.errors.key || error.response.data.errors || false;
                    this.error = Array.isArray(errors) ? errors[0] : errors;
                }).finally(() => this.loading = false);
        },
        updateRefLink(value) {

            let identifier = value.trim().replaceAll(' ', '');

            this.key = identifier;
            this.create_allowed = identifier.length > 4;
        },
        programLinkChange(event) {
            this.program_link = this.program_links[event.target.value];
        }
    },
    computed: {
        ref_link() {
            return this.program_link.url + this.key;
        }
    }
}
</script>
